"use client";

import type { InputHTMLAttributes } from "react";
import styles from "./Switch.module.css";

export interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
	options?: string[];
}

export const Switch = (props: SwitchProps) => {
	if (props.options) {
		return (
			<div className={styles["content-switch"]}>
				<input className={styles.toggle} type="checkbox" {...props} />
				<div className={styles.options}>
					{props.options.map((option, i) => (
						<span key={`${i}-option`}>{option}</span>
					))}
				</div>
			</div>
		);
	}
	return <input className={styles.toggle} type="checkbox" {...props} />;
};
